module.exports = __webpack_public_path__ + "static/media/15.240905dd.png";